import { apiConfig } from '@/config/api'
import storage from '@/utils/storage'
import { StorageKey } from '@/models/enums'
import { UserTokens } from '@/models/login'

class PageSpyManager {
    private timer: any = null
    private interval = 1000 * 60 * 1

    // Store instances in the class instead of window
    private harbor: any = null
    private rrweb: any = null
    private pageSpy: any = null

    public init() {
        if (this.pageSpy) return

        const api = 'pagespy.internal.aklrobot.com'
        const { mode, modeName } = apiConfig
        // 第二层开关：即使 index.html 那层（enablePageSpy）失效，这里也不会
        // 创建 PageSpy/RRWebPlugin/DataHarborPlugin 实例。生产构建里这行判断
        // 本身还是会被打进 JS 包（mode 是运行时读的 import.meta.env.MODE，
        // 不是能被 tree-shaking 消除的字面量），但运行时必然从这里直接 return。
        if (mode === 'production') return
        const tokens = storage.getItem(StorageKey.USER_TOKENS) as UserTokens

        // Initialize DataHarborPlugin
        if (window.DataHarborPlugin && !this.harbor) {
            this.harbor = new window.DataHarborPlugin()
        }

        // Initialize RRWebPlugin
        if (window.RRWebPlugin && !this.rrweb) {
            this.rrweb = new window.RRWebPlugin()
        }

        const plugins = [this.harbor, this.rrweb].filter(Boolean)

        // Initialize PageSpy
        if (window.PageSpy && !this.pageSpy) {
            plugins.forEach((p: any) => {
                window.PageSpy.registerPlugin(p)
            })

            this.pageSpy = new window.PageSpy({
                project: '大師航拍H5',
                api,
                clientOrigin: `https://${api}/`,
                autoRender: mode !== 'production',
                title: `[${modeName}] ${tokens ? tokens.nickname || navigator.userAgent : navigator.userAgent}`,
                serializeData: true,
            })
        }

        if (mode === 'test') {
            this.startUploadLog()
        }
    }

    private startUploadLog() {
        if (this.timer) return
        this.timer = setInterval(() => {
            if (this.harbor) {
                this.harbor.onOfflineLog('upload', true)
            }
        }, this.interval)
    }

    public stopUploadLog() {
        if (this.timer) {
            clearInterval(this.timer)
            this.timer = null
        }
    }

    public updateRoomInfo(info: any) {
        if (this.pageSpy) {
            this.pageSpy.updateRoomInfo(info)
        }
    }
}

const pageSpyManagerInstance = new PageSpyManager()

export function usePageSpy() {
    return pageSpyManagerInstance
}
